import './Home.css';
import Post from '../components/post/Post';
import { useState, useEffect, useContext } from 'react';
import AuthContext from '../../context/AuthProvider';
import { RiQuillPenLine } from 'react-icons/ri';
import { Link } from 'react-router-dom';
import { axiosInstance } from '../../config.util';

export default function Home(){
    const [posts, setPosts] = useState([]);
    const {authState:user} = useContext(AuthContext)
    // console.log('FROM HOME POST:',user);
    
    useEffect(()=>{
        const getpost = async ()=>{
            const postData = await axiosInstance.get("posts/logbook/"+user.id, {
                headers: {
                    "Authorization": `Bearer ${user.accessToken}`,
                },
            });
            setPosts(postData.data)
        }
        getpost()
    //CHEAT REAL TIME: 
    }, [user.accessToken, user.id, user.token])
    // })

    return(
        <div className="home">
            <div className="home__post">
                { posts.length === 0 
                ? ( 
                    <div className='no__post--message'>No Articles Yet 
                        <Link to={`/profile/${user.user}`} state={{searchUsrId: user.id}}>
                            <div className='no__post--icon'> Create One 
                                <span className='no__post--infe'> <RiQuillPenLine /> </span>
                            </div>
                        </Link>
                    </div> ) 
                : posts.map(post=><Post key={post._id} post={post} />) 
                }
            </div>
        </div>
    )
}